import React from 'react';
import dynamic from 'next/dynamic';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';

const DialogWrapper = dynamic(() => import('@components/catalog/my-sizes/my-sizes/dialog-wrapper/dialog-wrapper'), {
  ssr: false,
});

const SIZES_HOTFILTER_ID = 'hot-filter-button-CATALOG.FILTERS.SIZES.TITLE';

const CatalogMySizesModal = () => {
  const areMySizesApplicable = useContextSelector(CatalogContext, (v) => v.areMySizesApplicable);
  const mySizesDialogOpen = useContextSelector(CatalogContext, (v) => v.mySizesDialogOpen);
  const setMySizesDialogOpen = useContextSelector(CatalogContext, (v) => v.setMySizesDialogOpen);
  const setDialogOpen = (isOpen: boolean) => {
    setMySizesDialogOpen(isOpen);
    if (!isOpen) {
      setTimeout(() => {
        document.getElementById(SIZES_HOTFILTER_ID)?.focus();
      }, 100);
    }
  };

  return (
    mySizesDialogOpen && (
      <DialogWrapper
        dialogOpen={mySizesDialogOpen}
        setDialogOpen={setDialogOpen}
        canActivateSizes={areMySizesApplicable}
      />
    )
  );
};

export default CatalogMySizesModal;
